<template style="z-index: 0;position: absolute;">
  <v-container pa-0 fluid>
    <v-layout column align-center>
      <v-card class="home-header d-flex">
        <div class="home-bg">
          <v-flex lg10 xs12 class="home-hero-content text-xs-center text-lg-left">
            <h1 style="font-family:monospace!important">Terms of Service &<br>Privacy Policy</h1>
          </v-flex>
          <section>
            <h2>Terms of Use</h2>
            <p>1. Introduction</p>
            <p>These Terms of Service ("Terms") govern your use of the BlakeJS website ("the Site"). By accessing or using the Site, you agree to be bound by these Terms.</p>

            <p>2. Use of the Site</p>
            <p>2.1. The Site is provided for informational and personal use only. You may not use the Site for any commercial or illegal purposes.</p>
            <p>2.2. You are responsible for your use of the Site.</p>

            <p>3. Intellectual Property</p>
            <p>The Site and all its content are the property of their respective owners and are protected by copyright and other intellectual property laws. You may not reproduce, distribute, or modify any content without prior written consent.</p>

            <p>4. Disclaimers</p>
            <p>4.1. The Site is provided "as is" without warranties of any kind, express or implied.</p>
            <p>4.2. BlakeJS.com does not warrant that the Site will be uninterrupted or error-free.</p>

            <p>5. Limitation of Liability</p>
            <p>In no event shall BlakeJS.com be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with your use of the Site.</p>

            <p>6. Governing Law</p>
            <p>These Terms shall be governed by and construed in accordance with the laws of Your Jurisdiction.</p>

            <p>7. Modifications</p>
            <p>We reserve the right to modify or update these Terms at any time. Your continued use of the Site after any such changes constitutes your acceptance of the new Terms.</p>
          </section>
          <section>
            <h2>Privacy Policy</h2>
            <p>1. Information Collection</p>
            <p>We do not collect any personal information from visitors to this Site.</p>

            <p>2. Cookies</p>
            <p>The Site may use cookies to enhance your browsing experience, but these cookies do not collect or store any personal information.</p>

            <p>3. Third-Party Links</p>
            <p>The Site may contain links to third-party websites or services that are not owned or controlled by BlakeJS.com. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

            <p>4. Changes to this Privacy Policy</p>
            <p>We reserve the right to modify or update this Privacy Policy at any time. Any changes will be effective immediately upon posting the revised Privacy Policy on the Site.</p>
          </section>
        </div>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Terms",
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.home-header {
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
}

.home-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #E4E4E1;
  background-repeat: repeat;
  object-fit: fill;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.home-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #E4E4E1;
  background-repeat: repeat;
  object-fit: fill;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.home-bg section {
  max-width: 800px;
  padding: 0 18px;
}
</style>



// WEBPACK FOOTER //
// src/page/Terms.vue